import { IntegrationTokensLogo } from "@via/utils/constants";

export { createFilterQuery } from "@via/api/integration-tokens-filter-query";

export const getTokenTypeIcon = (tokenType: string) => {
  switch (tokenType) {
    case "gCloud":
      return IntegrationTokensLogo.googleCloud;
    case "openai":
      return IntegrationTokensLogo.openAi;
    case "anthropic":
      return IntegrationTokensLogo.anthropic;
    case "baseSpace":
      return IntegrationTokensLogo.baseSpace;
    case "gemini":
      return IntegrationTokensLogo.gemini;
    case "github":
      return IntegrationTokensLogo.github;
    case "gitlab":
      return IntegrationTokensLogo.gitlab;
    case "bitbucket":
      return IntegrationTokensLogo.bitbucket;
    case "tamarind":
      return IntegrationTokensLogo.tamarind;
    default:
      return IntegrationTokensLogo.openAi;
  }
};

export const tokenTypeOptions = [
  {
    label: "Google Cloud Service",
    value: "gCloud",
    icon: IntegrationTokensLogo.googleCloud,
  },
  {
    label: "OpenAI",
    value: "openai",
    icon: IntegrationTokensLogo.openAi,
  },
  {
    label: "Claude",
    value: "anthropic",
    icon: IntegrationTokensLogo.anthropic,
  },
  {
    label: "Gemini",
    value: "gemini",
    icon: IntegrationTokensLogo.gemini,
  },
  {
    label: "BaseSpace",
    value: "baseSpace",
    icon: IntegrationTokensLogo.baseSpace,
  },
  {
    label: "GitHub",
    value: "github",
    icon: IntegrationTokensLogo.github,
  },
  {
    label: "GitLab",
    value: "gitlab",
    icon: IntegrationTokensLogo.gitlab,
  },
  {
    label: "Bitbucket",
    value: "bitbucket",
    icon: IntegrationTokensLogo.bitbucket,
  },
  {
    label: "Tamarind",
    value: "tamarind",
    icon: IntegrationTokensLogo.tamarind,
  },
];
